import {Component, Input} from "@angular/core";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {EditService} from "../../../framework/entity/edit/edit-page/edit.service";

@Component({
    selector: "wbo-entity-group-by-report-criteria",
    templateUrl: "./entity-group-by-report-criteria.component.html"
})
export class EntityGroupByReportCriteriaComponent {
    public static NO_GROUP_VALUE = "SIMPLE";
    public static DAY_GROUP_VALUE = "SIMPLE";
    public static DISCOUNT_VALUE = "DISCOUNT";
    public static SURCHARGE_VALUE = "SURCHARGE";
    public static SALE_VALUE = "SALE";
    public static INVENTORY_GROUP_VALUE = "INVENTORY_GROUP";
    public static INVENTORY_VALUE = "INVENTORY";
    public static SUPPLIER_VALUE = "SUPPLIER";
    public static OUTLET_VALUE = "OUTLET";
    public static LOCATION_VALUE = "LOCATION";
    public static PRODUCT_VALUE = "PRODUCT";
    public static EMPLOYEE_VALUE = "EMPLOYEE";
    public static TERMINAL_VALUE = "TERMINAL";
    public static MOVEMENT_VALUE = "MOVEMENT";
    public static MEMBER_VALUE = "MEMBER";
    public static MEMBERSHIP_TYPE_VALUE = "MEMBERSHIP_TYPE";
    public static ACTION_TYPE_VALUE = "actionType";

    EntityGroupByReportCriteriaComponent = EntityGroupByReportCriteriaComponent;

    @Input() showNoGroupOption: boolean = true;
    @Input() showDayGroupOption: boolean = false;
    @Input() showLocationOption: boolean = false;
    @Input() showOutletOption: boolean = false;
    @Input() showInventoryOption: boolean = false;
    @Input() showInventoryGroupOption: boolean = false;
    @Input() showSupplierOption: boolean = false;
    @Input() showPreferredSupplierOption: boolean = false;
    @Input() showEmployeeOption: boolean = false;
    @Input() showProductOption: boolean = false;
    @Input() showTerminalOption: boolean = false;
    @Input() showMovementOption: boolean = false;
    @Input() showDiscountOption: boolean = false;
    @Input() showSurchargeOption: boolean = false;
    @Input() showSaleOption: boolean = false;
    @Input() showMembershipTypeOption: boolean = false;
    @Input() showMemberOption: boolean = false;
    @Input() showActionOption: boolean = false;
    @Input() readonly: boolean = false;

    constructor(public model: ReportModel<any>, public editService: EditService) {
    }
}
